import { createFeatureSelector } from '@ngrx/store';
import { adminGeneralFeatureKey, AdminGeneralState } from './general/admin.reducer';

export const selectFeatureGeneralAdmin =
  createFeatureSelector<AdminGeneralState>(adminGeneralFeatureKey);
